module.exports = __webpack_public_path__ + "img/linkedin-white.54b4496e.svg";